import $ from "jquery";
import "slick-slider";

const slickDefaults = {
  autoplay: false,
  autoplaySpeed: 7000,
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true,
  prevArrow: `
    <button type="button" class="slick-prev" aria-label="Previous Slide">
      <div class="icon" aria-hidden="true">
        <i class="far fa-angle-left accordion-item__icon-svg"></i>
      </div>
    </button>`,
  nextArrow: `
    <button type="button" class="slick-next" aria-label="Next Slide">
      <div class="icon" aria-hidden="true">
        <i class="far fa-angle-right accordion-item__icon-svg"></i>
      </div>
    </button>`,
};

export default function slickSlider(el, conf, callback) {
  // do not intialize slideshows inside page editor
  if ($("body").hasClass("is-page-editor")) {
    return;
  }

  const $slider = $(el);
  const dataAutoRotate = el.closest(".slideshow").getAttribute("data-auto-rotate");
  console.log("dataAutoRotate:", dataAutoRotate);
  const autoplay = dataAutoRotate && dataAutoRotate.toLowerCase() === "true";

  const config = Object.assign({}, slickDefaults, conf, { autoplay });

  // create a region to tell the user which slide is active
  const liveregion = document.createElement("div");
  liveregion.setAttribute("aria-live", "polite");
  liveregion.setAttribute("aria-atomic", "true");
  liveregion.setAttribute("class", "slick-slider__info u-visuallyhidden");

  // populate the live region after Slick has been run
  $slider.on("init", (event, slick) => {
    liveregion.textContent = `Item ${slick.currentSlide + 1} of ${
      slick.slideCount
    }`;
    el.appendChild(liveregion);
  });

  $slider.on("afterChange", (event, slick, currentSlide) => {
    liveregion.textContent = `Item ${currentSlide + 1} of ${slick.slideCount}`;

    if (typeof callback === "function") {
      callback(event, slick, currentSlide);
    }
  });

  // create the slider
  $slider.slick(config);
}
